import React from 'react';
import { Box, HStack, Avatar } from '@chakra-ui/react';
import './TypingIndicator.css';

interface TypingIndicatorProps {
  assistantBg?: string;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({
  assistantBg = 'gray.700',
}) => {
  return (
    <HStack alignSelf='flex-start' spacing={2} maxW='85%'>
      <Avatar size='sm' name='AI' bg='primary.500' color='white' />
      <Box
        bg={assistantBg}
        px={4}
        py={3}
        borderRadius='lg'
        boxShadow='md'
        className='typing-indicator-container'
      >
        <HStack spacing={1} className='typing-dots'>
          <Box className='typing-dot' />
          <Box className='typing-dot' />
          <Box className='typing-dot' />
        </HStack>
      </Box>
    </HStack>
  );
};

export default TypingIndicator;
